import { Injectable } from '@angular/core';
import { User } from '../types/User';
import { VueAppDefaultsService, VueSessionCookieService } from '@vue/vueframework';
import { Client } from '../types/Client';

@Injectable({
  providedIn: 'root'
})

/**
 * Service to store data in session; can be used in resolvers.
 */
export class SessionDataService {
  private user: User;
  private loginURL: string;
  private client: Client;
  private readonly namespace = 'VUE-AR';
  private readonly localeKey = 'locale';

  public constructor(
    private vueAppDefaultsService: VueAppDefaultsService,
    private vueSessionCookieService: VueSessionCookieService,
  ) {
    this.setLocale(this.getLocale() ? this.getLocale() : 'en_US');
  }

  public getUser(): User {
    return this.user;
  }

  public setUser(newUser: User): void {
    this.user = newUser;
  }

  public getLocale(): string {
    return this.vueSessionCookieService.getAttribute(this.localeKey, this.namespace);
  }

  public setLocale(locale: string): void {
    this.vueSessionCookieService.setAttribute(this.localeKey, locale, this.namespace);
  }

  public getLoginURL(): string {
    return this.loginURL;
  }

  public setLoginURL(loginURL: string): void {
    this.loginURL = loginURL;
  }

  public getClient(): Client {
    return this.client;
  }

  public setClient(client: Client): void {
    this.client = client;
  }
}
